/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import { Checkbox } from '../../ts-components/Checkbox'
import { FormAction } from '../reducer/useFeedPostReducer'
import colors from '@sportninja/common/constants/appColors'
import Text from '../../ts-components/Text'

interface CommunicationChannelProps {
  postToFeed: boolean
  sendViaEmail: boolean
  sendViaPush: boolean
  dispatch: React.Dispatch<FormAction>
  isSelectedTypeOrg: boolean
  hasUpdateOrAdminPermission: boolean
}

/**
 * CommunicationChannel component - handles post distribution method toggles
 *
 * This component manages the switches for different communication channels:
 * - Post to Feed: Whether to publish on the social feed
 * - Send via Email: Whether to notify audience by email
 * - Send via Push Notification: Whether to send push notifications
 *
 * The component only displays when the selected entity is an organization
 * and the user has appropriate permissions.
 *
 * @param props - Component props for form state and dispatch function
 * @returns JSX element representing the communication channel toggles
 */
export const CommunicationChannel: React.FC<CommunicationChannelProps> = ({
  postToFeed,
  sendViaEmail,
  sendViaPush,
  dispatch,
  isSelectedTypeOrg,
  hasUpdateOrAdminPermission,
}) => {
  // if (!isSelectedTypeOrg || !hasUpdateOrAdminPermission) {
  if (!hasUpdateOrAdminPermission) {
    console.log(
      '🔄 CommunicationChannel: Not rendering - insufficient permissions',
      {
        isSelectedTypeOrg,
        hasUpdateOrAdminPermission,
      }
    )
    return null
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-self: stretch;
        width: 100%;
      `}
    >
      <Text variant='paragraphSmall' weight='medium' color={colors.WHITE}>
        Notify Via:
      </Text>

      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 8px;
        `}
      >
        <Checkbox
          label='Social Feed'
          hint='Visible on the main social feed'
          name='postToFeed'
          value={postToFeed}
          onChange={(e) =>
            dispatch({
              type: 'SET_FIELD',
              field: 'postToFeed',
              payload: e.target.checked,
            })
          }
        />

        <Checkbox
          label='Email'
          hint='Notify the selected audience by email'
          name='sendViaEmail'
          value={sendViaEmail}
          onChange={(e) =>
            dispatch({
              type: 'SET_FIELD',
              field: 'sendViaEmail',
              payload: e.target.checked,
            })
          }
        />

        <Checkbox
          label='Push Notification'
          hint='Send a push notification to the audience'
          name='sendViaPush'
          value={sendViaPush}
          onChange={(e) =>
            dispatch({
              type: 'SET_FIELD',
              field: 'sendViaPush',
              payload: e.target.checked,
            })
          }
        />
      </div>
    </div>
  )
}
